import { commonjsGlobal as t } from "./index.es13.js";
import { __exports as e } from "./index.es96.js";
import n from "./index.es97.js";
var o;
function m() {
  if (o) return e;
  o = 1;
  var a = t && t.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(e, "__esModule", { value: !0 });
  var u = a(n), i = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.fromCodePoint || function(r) {
      var f = "";
      return r > 65535 && (r -= 65536, f += String.fromCharCode(r >>> 10 & 1023 | 55296), r = 56320 | r & 1023), f += String.fromCharCode(r), f;
    }
  );
  function _(r) {
    return r >= 55296 && r <= 57343 || r > 1114111 ? "�" : (r in u.default && (r = u.default[r]), i(r));
  }
  return e.default = _, e;
}
export {
  m as __require
};
//# sourceMappingURL=index.es94.js.map
